<template>
  <div class="games-slider">
    <GridSlider
      :list="list"
      class="games-slider__slider"
    >
      <template #headline>
        <UiText
          class="games-slider__title"
          color="typography-body01"
          font="body-text-small"
          :text="$t('lobby.search.news')"
        />
      </template>

      <template #default="{ data }">
        <CardGame class="games-slider__card" :data="data" :is-footer="false" />
      </template>

      <template #last>
        <slot v-if="$slots.last" name="last" />
      </template>
    </GridSlider>
  </div>
</template>

<script>
import GridSlider from '~/components/Base/GridSlider'
import CardGame from '@/components/shared/Cards/CardGame'

export default {
  name: 'GamesSlider',
  components: {
    GridSlider,
    CardGame,
  },
  props: {
    list: { type: Array },
  },
}
</script>

<style lang="scss" scoped>
.games-slider {
  width: 100%;
  max-width: 640px;
  padding: var(--spaces-s) var(--spaces-l) var(--spaces-l) var(--spaces-l);
  border-radius: 32px;
  background: var(--alert-grey-transparent-bg-color);
  overflow: hidden;
  margin: 0 auto;

  &__slider {
    overflow: visible;
  }

  &__card {
    width: 122px;

    @include media(new-tablet) {
      width: 112px;
    }
  }

  &__title {
    margin-bottom: var(--spaces-s);
    color: var(--typography-body-general);
    @include body-text-small;
    text-align: center;
    display: block;

    @include media(new-tablet) {
      margin: var(--spaces-s) 0;
      height: 45px;
      display: flex;
      align-items: center;
      @include body-text;
      text-align: left;
    }
  }
}
</style>
